<template>
  <v-main fluid class="pa-0 fill-height grey lighten-3">
    <div style="position:absolute;top:12px;left:12px;">
      <router-link to="/">
        <v-img :src="`${Utility.RES_SERVER}/static/img/logo.png`" width="180" contain></v-img>
      </router-link>
    </div>
    <v-row style="margin-top:100px;" justify="center">
      <v-col cols="4" class="pb-0">
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step step="1" complete>获取验证码</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2">设置新密码</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3">完成</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <forgot-step1 @change="onStep1Change"></forgot-step1>
            </v-stepper-content>

            <v-stepper-content step="2">
              <forgot-step2 @change="onStep2Change" @back="onStep2Back"></forgot-step2>
            </v-stepper-content>

            <v-stepper-content step="3">
              <forgot-step3></forgot-step3>
            </v-stepper-content>

          </v-stepper-items>

        </v-stepper>
      </v-col>
    </v-row>

  </v-main>
</template>
<script>
import { forgotUpdatePassword } from '@/plugins/api';

export default {
  data () {
    return {
      step: 1,
      billData: {}
    }
  },
  methods: {
    onStep1Change (data) {
      this.billData = { ...data };
      this.step++;
    },
    onStep2Change (password) {
      this.billData.password = password;
      forgotUpdatePassword(this.billData).then(() => {
        this.step++;
      })
    },
    onStep2Back () {
      this.step--;
    }
  },
  components: {
    ForgotStep1: () => import('./ForgotStep1.vue'),
    ForgotStep2: () => import('./ForgotStep2.vue'),
    ForgotStep3: () => import('./ForgotStep3.vue')
  }
}
</script>